import { useState } from "react";
import { accountService, subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import {
  IAccountDetailsResponse,
  IMaterialsResponse,
  ISubscriptionResponse,
} from "@miplatform/types";
import { groupBy } from "@miplatform/utils";
import { useSession } from "@mibuildweb/hooks";

export const groupAndSortMaterialsByCategory = (
  materials: IMaterialsResponse[]
): Record<string, IMaterialsResponse[]> => {
  const grouped = groupBy(
    materials,
    (material: IMaterialsResponse) => material.category.categoryId
  ) as Record<string, IMaterialsResponse[]>;

  Object.values(grouped).forEach((items) => {
    items.sort((a, b) =>
      (a.manufacturerPartNumber ?? "").localeCompare(
        b.manufacturerPartNumber ?? ""
      )
    );
  });

  return grouped;
};

export const useCustomerPricingDetailsViewModel = () => {
  const {
    session: { tenantId },
  } = useSession();

  const [accountDetails, setAccountDetails] =
    useState<IAccountDetailsResponse | null>(null);
  const [tenantDetails, setTenantDetails] =
    useState<ISubscriptionResponse | null>(null);

  const stateManager = useComponentState();

  const getAccountDetails = (id: string) => {
    return stateManager.run(async () => {
      const response = await accountService.accounts.getAccountById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        setAccountDetails(response.data);
      }
      return response;
    });
  };

  const getTenantDetails = () => {
    return stateManager.run(async () => {
      const response = await subscriptionService.subscriptions.get(tenantId);
      if (response.status === HTTP_STATUSES.OK) {
        setTenantDetails({
          ...response.data,
          invoiceTermsAndConditionsHtml: "",
        });
      }
      return response;
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    stateManager,
    accountDetails,
    tenantDetails,
    getAccountDetails,
    getTenantDetails,
  };
};
